import React, { useState, useEffect, useRef, CSSProperties, MutableRefObject } from "react";
import { Dimmer, Loader } from "semantic-ui-react";
import { useIntl } from "react-intl";

const COLORS = {
  divider: "rgba(228, 218, 218, 0.5)",
  dark_grey: "#746A6A",
};

const styles = {
  message_search: {
    position: "absolute",
    width: "100%",
    background: "white",
    zIndex: 1,
    left: 0,
    overflow: "auto",
  } as CSSProperties,
};

type CardMessageListProps = {
  // data
  search: string;
  searchList?: any[];
  isEndOfList?: boolean;
  style: CSSProperties;

  // callback
  onScrollToBottom?: Function;
  onSelected?: (select: any, index: number) => void;
};

const CardMessageList = React.memo<CardMessageListProps>((props) => {
  const intl = useIntl();
  const [isBottomLoading, setIsBottomLoading] = useState<boolean>(false);

  const isLaxyLoad = useRef<boolean>(false);
  const messageListRef = useRef() as MutableRefObject<HTMLDivElement>;

  useEffect(() => {
    const bodyRef = messageListRef.current;

    if (!bodyRef) {
      return;
    }

    bodyRef.onscroll = async () => {
      const isBottom = bodyRef.scrollTop + bodyRef.offsetHeight + 15 >= bodyRef.scrollHeight;
      if (!isLaxyLoad.current && isBottom && !props.isEndOfList) {
        isLaxyLoad.current = true;
        setIsBottomLoading(true);

        props.onScrollToBottom?.();
      }
    };

    return () => {
      bodyRef.onscroll = null;
    };
  }, [props.searchList, props.isEndOfList]);

  useEffect(() => {
    isLaxyLoad.current = false;
    setIsBottomLoading(false);
  }, [props.searchList]);

  const handleClick = (item: any, index: number) => (e: any) => {
    props.onSelected?.(item, index);
  };

  return (
    <>
      <div ref={messageListRef} style={{ ...styles.message_search, ...props.style }}>
        {(props.searchList || []).map((item, index) => {
          const cleanText = (props.search || "").replace(
            /(\.|\+|\*|\?|\^|\$|\(|\)|\[|\]|\{|\}|\||\\)/g,
            "\\$1"
          );

          const reg = new RegExp(`(${cleanText})`, "g");
          const content = item.content.replace(
            reg,
            `<span style='background-color:#5DBCD2; color:white; padding:1px 0 3px;'>$1</span>`
          );

          return (
            <div
              key={"message-list-" + index}
              style={{
                borderBottom: `1px solid ${COLORS.divider}`,
                padding: "7.5px 15px",
                cursor: "pointer",
              }}
              onClick={handleClick(item, index)}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontWeight: "bold" }}>{item.author?.full_name || ""}</div>
                <div style={{ color: COLORS.dark_grey }}>{item.send_at}</div>
              </div>
              <div style={{ padding: "3px 0" }} dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          );
        })}

        {isBottomLoading && (
          <Dimmer
            active={true}
            inverted
            style={{
              background: "transparent",
              position: "relative",
              zIndex: "auto",
              paddingTop: "60px",
              height: "30px",
            }}
          >
            <Loader inverted></Loader>
          </Dimmer>
        )}

        {props.isEndOfList && (
          <div
            style={{
              textAlign: "center",
              fontSize: "16px",
              padding: "10px 0",
              color: COLORS.dark_grey,
            }}
          >
            {intl.formatMessage({ id: "สิ้นสุดรายการ" })}
          </div>
        )}
      </div>
    </>
  );
});

CardMessageList.displayName = "CardMessageList";

export default CardMessageList;
